import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const ModalWrapper = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 15% ${tvar('space.x2')};
`;

export const ModalContent = styled.div`
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #888;
  min-width: 25rem;
  max-width: 100%;
  width: max-content;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: ${tvar('colors.fill.primary')};
`;

export const CloseButton = styled.button<{ $insideContent?: boolean }>`
  float: ${({ $insideContent }) => ($insideContent ? 'right' : 'none')};
  position: ${({ $insideContent }) => ($insideContent ? 'static' : 'fixed')};
  top: ${({ $insideContent, theme }) =>
    $insideContent ? 'auto' : theme.space.x2};
  right: ${({ $insideContent, theme }) =>
    $insideContent ? 'auto' : theme.space.x4};
  font-size: 2.4rem;
  border: 0;
  background: 0;
  box-shadow: 0;
  cursor: pointer;
  margin-left: ${tvar('space.x2')};
  margin-bottom: ${tvar('space.x2')};
`;
